import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';

const ArticleCards = ({ data, topic, type = 'standard' }) => {
  const {
    cardImage: image,
    cardImageLong: imageLong,
    cardImageTall: imageTall,
    franchise,
    header: { headline },
    slug,
    title,
  } = data;
  const { franchiseName } = franchise || {};

  const imageContainer = (imageType = image) => (
    <div className="card-image">
      <GatsbyImage
        alt={title}
        image={getImage(imageType)}
        style={{ height: '100%' }}
      />
    </div>
  );

  const imageFeaturedContainer = (imageType = image) => (
    <div className="card-image featured">
      <GatsbyImage
        alt={title}
        image={getImage(imageType)}
        style={{ height: '100%' }}
      />
    </div>
  );

  const typeMap = {
    featured: !topic && (
      <div
        className="card-container featured"
        data-component-id="card_container_featured"
      >
        {imageFeaturedContainer(image)}
        <div className="card-content featured">
          <div className="card-category">{franchiseName}</div>
          <h6 className="card-headline">{title}</h6>
          <div className="card-subheadline">{headline}</div>
        </div>
      </div>
    ),
    long: (
      <div
        className="card-container long"
        data-component-id="card_container_long"
      >
        {imageContainer(imageLong)}
        <div className="card-content long">
          <div className="card-category">{franchiseName}</div>
          <h6 className="card-headline">{title}</h6>
        </div>
      </div>
    ),
    standard: (
      <div
        className="card-container"
        data-component-id="card_container_standard"
      >
        {imageContainer(image)}
        <div className="card-content standard">
          <div className="card-category">{franchiseName}</div>
          <h6 className="card-headline">{title}</h6>
        </div>
      </div>
    ),
    tall: !topic && (
      <div
        className="card-container tall"
        data-component-id="card_container_tall"
      >
        {imageContainer(imageTall)}
        <div className="card-content tall">
          <div className="card-category">{franchiseName}</div>
          <h6 className="card-headline">{title}</h6>
        </div>
      </div>
    ),
  };

  return (
    <Link to={`/article/${slug || ''}/`}>
      <div className="article-content-card">{typeMap[type]}</div>
    </Link>
  );
};

ArticleCards.propTypes = {
  data: PropTypes.object,
  topic: PropTypes.bool,
  type: PropTypes.string,
};

export default ArticleCards;
